export default __webpack_public_path__ + "static/media/search-icon.16d0739b.svg";